export const INVALID_DATE = 'INVALID_DATE';
export const INVALID_DATETIME = 'INVALID_DATETIME';
export const INVALID_NUMBER = 'INVALID_NUMBER';
export const INVALID_USER_ID = 'INVALID_USER_ID';
export const INVALID_CASCADE_SELECT_FORMAT = 'INVALID_CASCADE_SELECT_FORMAT';
export const INVALID_COMMENT_FORMAT = 'INVALID_COMMENT_FORMAT';
export const INVALID_WORKLOG_FORMAT = 'INVALID_WORKLOG_FORMAT';

export const EMPTY_SUMMARY = 'EMPTY_SUMMARY';
export const GENERIC_ERRORS = 'GENERIC_ERRORS';
export const INVALID_ISSUE_ID = 'INVALID_ISSUE_ID';

export type ValidationErrorType =
	| typeof INVALID_DATE
	| typeof INVALID_DATETIME
	| typeof INVALID_NUMBER
	| typeof INVALID_USER_ID
	| typeof INVALID_CASCADE_SELECT_FORMAT
	| typeof INVALID_COMMENT_FORMAT
	| typeof INVALID_WORKLOG_FORMAT
	| typeof EMPTY_SUMMARY
	| typeof GENERIC_ERRORS
	| typeof INVALID_ISSUE_ID;

export const DATE_ERROR_TYPES: Set<ValidationErrorType> = new Set([INVALID_DATE, INVALID_DATETIME]);
